import { FC } from "react";

import { IconProps, initializeSvgIconProps } from "mds/utils/images";

export const ClockIcon: FC<IconProps> = (props) => (
  <svg {...initializeSvgIconProps(props)}>
    <path
      d="M14.1663 8.00031C14.1663 4.59466 11.4059 1.83349 8.00033 1.83331C4.59457 1.83331 1.83333 4.59455 1.83333 8.00031C1.83351 11.4059 4.59468 14.1663 8.00033 14.1663C11.4058 14.1661 14.1662 11.4058 14.1663 8.00031ZM15.1663 8.00031C15.1662 11.9581 11.9581 15.1661 8.00033 15.1663C4.04239 15.1663 0.833509 11.9582 0.833333 8.00031C0.833333 4.04226 4.04228 0.833313 8.00033 0.833313C11.9582 0.833489 15.1663 4.04237 15.1663 8.00031Z"
      fill="currentColor"
    />
    <path
      d="M7.5 4C7.5 3.72386 7.72386 3.5 8 3.5C8.27614 3.5 8.5 3.72386 8.5 4V7.5H10.667C10.943 7.50018 11.167 7.72397 11.167 8C11.167 8.27603 10.943 8.49982 10.667 8.5H8C7.72386 8.5 7.5 8.27614 7.5 8V4Z"
      fill="currentColor"
    />
  </svg>
);
